import EventEmitter from 'tiny-emitter'

// Export singleton of tiny emitter
export default new EventEmitter()
